<!--  -->
<template>
  <div class="introbgc">
    <div class="container intro">
      <h4>关于ISE学者评价</h4>
      <h5 class="mt35">什么是ISE</h5>
      <p>ISE（Internet Scholar Evaluation）是由人大数媒全新推出的开放学者评价模型，破除“唯论文、唯帽子、唯职称、唯学历、唯奖项”的科研评价体系，以学者为中心，以代表作为核心，通过互联网开放评价并辅以严谨的人工智能算法，客观地对学者进行透视评鉴，体现学者的科研水准与学术价值，并形成动态学者榜单，实时更新。</p>
      
      <h5 class="mt35">学者榜单简介</h5>
      <p>1、学者榜单共包含人文社科领域的8个学科门类，22个一级学科，70个二级学科，以二级学科为单位共70个学者榜单。</p>
      <p>2、根据所有学者近年来发表的论文，结合人大复印库的转载情况，通过全新的人工智能算法所评选得出，文献的计算范围是近10年(2009年以来发表)的论文。</p>
      <p>3、评价的主要依据是有影响力的代表作，因此跨学科的学者可能会在不同学科榜单中重复出现。</p>
      <p>注：首批共有30个学科榜单发布，剩余榜单后续将会陆续发布，敬请期待！</p>
      
      <h5 class="mt35">ISE学者评级</h5>
      <p>1、学者得分组成</p>
      <p>60% × 代表作得分 + 30% × top(2~5)论文得分 + 10% × 人大复印库转载量换算值</p>
      <p>注：论文得分由中国人民大学人文社科评价中心自主研发的人工智能算法得出</p>
      <p>2、根据学者得分选出上榜学者，所有上榜学者分为三个等级</p>
      <p>AAAAA(顶尖)，AAAA(杰出)，AAA(优秀)</p>
      
      
      <!-- <h5 class="mt35">ISE评价等级</h5>
      <p>根据学者成果的突破程度（重大突破——>一般突破——>小突破）共分为5个等级：AAAAA、AAAA、AAA、AA、A，初始榜单只设3个等级：AAA、AA、A，且带有“待定”标记作为初始参考，当学者的评价累计到一定数量后会根据评价结果转为正式等级(消除“待定”标记)，学者的等级会根据评价的结果的变化而变化，对于公认成果没有突破或学术造假的学者将被踢出榜单。</p>
      
      <h5 class="mt35">学者认领和申请上榜(暂未上线)</h5>
      <p>当确认榜单中的学者是本人后，可以认领该学者并获得其编辑权，包括完善学者信息，确认或重新上传代表作等。对于未上榜的学者可以上传代表作并提交上榜申请。以上功能的具体细节将在开放后详细说明。</p>


      <h5 class="mt35">开放式评价(暂未上线)</h5>
      <p>所有壹学者实名认证的用户均可进行评价，该功能将在所有初始榜单发布完成后开放，具体评价方式和规则待开放后公布。</p> -->
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.introbgc {
  background: rgba(246, 246, 246, 1);
}
.introbgc img{
    margin-top: 20px;
    margin-bottom: 20px;
}
.introbgc .mt30{
    margin-top: 30px;
}
.introbgc .mt35{
    margin-top: 35px;
}
.introbgc .mt10{
    margin-top: 10px;
}
.introbgc .ml25{
    margin-left: 25px;
}
.introbgc .ml150{
    margin-left: 150px;
}
.introbgc .pl25{
    padding-left: 25px;
}
.intro {
  padding: 45px 40px 140px;
  background-color: #fff;
}
.intro h4 {
  font-size: 16px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  text-align: center;
}

.intro h5,.intro p {
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}
.intro h5{
    font-weight: 600;
    color: #000;
}
.intro p {
    color: #666666;
}
</style>


// WEBPACK FOOTER //
// src/view/introduce/intro.vue